//TODO: use enum from GraphQL
export enum QConfigPublishValidationErrorCode {
  TOTAL_QUESTIONS_BELOW_LIMIT = 'TOTAL_QUESTIONS_BELOW_LIMIT',
  TOTAL_QUESTIONS_EXCEED = 'TOTAL_QUESTIONS_EXCEED',
  PASSING_CRITERIA_NOT_DEFINED = 'PASSING_CRITERIA_NOT_DEFINED',
  EXAM_TIMING_NOT_DEFINED = 'EXAM_TIMING_NOT_DEFINED',
  QUESTION_RANDOMIZATION_NOT_DEFINED = 'QUESTION_RANDOMIZATION_NOT_DEFINED',
  QUESTIONS_NOT_ENOUGH = 'QUESTIONS_NOT_ENOUGH',
  Q_BANK_STRUCTURE_NOT_DEFINED = 'Q_BANK_STRUCTURE_NOT_DEFINED',
  Q_CONFIG_STRUCTURES_ON_TIME_LIMIT_NOT_COMPLETE = 'Q_CONFIG_STRUCTURES_ON_TIME_LIMIT_NOT_COMPLETE',
  DISABLED_LEARNING_OBJECTIVE_STATEMENTS_FOUND = 'DISABLED_LEARNING_OBJECTIVE_STATEMENTS_FOUND',
}

export const QCONFIG_PUBLISH_ERROR_MESSAGES: Record<string, string> = {
  TOTAL_QUESTIONS_BELOW_LIMIT: 'จำนวนข้อสอบไม่ครบตามที่กำหนด',
  TOTAL_QUESTIONS_EXCEED: 'จำนวนข้อสอบเกินจากที่กำหนด',
  PASSING_CRITERIA_NOT_DEFINED: 'กรุณากำหนดเกณฑ์การผ่าน',
  EXAM_TIMING_NOT_DEFINED: 'กรุณากำหนดระยะเวลาทำข้อสอบ',
  QUESTION_RANDOMIZATION_NOT_DEFINED: 'กรุณาเลือกรูปแบบการสุ่มคำถาม',
  Q_BANK_STRUCTURE_NOT_DEFINED: 'กรุณากำหนดโครงสร้างข้อสอบ',
  Q_CONFIG_STRUCTURES_ON_TIME_LIMIT_NOT_COMPLETE: 'กรุณาเลือกหมวดให้ครบถ้วน',
  DISABLED_LEARNING_OBJECTIVE_STATEMENTS_FOUND: 'LOS ถูกปิดการใช้งาน (Disable LOS)',
};

export const publishQConfigErrorsByPage = {
  'QConfig Overview': [
    QConfigPublishValidationErrorCode.TOTAL_QUESTIONS_EXCEED,
    QConfigPublishValidationErrorCode.TOTAL_QUESTIONS_BELOW_LIMIT,
    QConfigPublishValidationErrorCode.Q_BANK_STRUCTURE_NOT_DEFINED,
    QConfigPublishValidationErrorCode.DISABLED_LEARNING_OBJECTIVE_STATEMENTS_FOUND,
  ],
  'QConfig Settings': [
    QConfigPublishValidationErrorCode.PASSING_CRITERIA_NOT_DEFINED,
    QConfigPublishValidationErrorCode.EXAM_TIMING_NOT_DEFINED,
    QConfigPublishValidationErrorCode.QUESTION_RANDOMIZATION_NOT_DEFINED,
    QConfigPublishValidationErrorCode.Q_CONFIG_STRUCTURES_ON_TIME_LIMIT_NOT_COMPLETE,
  ],
};
